'use client'

import Error from '@/src/shared/ui/error'

const NotFoundPage = () => {
  return <Error status={404}>Страница не найдена</Error>
}

export default NotFoundPage
